"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import { knappKlikket } from "@/common/analytics/events-and-properties/knappKlikket-properties";
import { TrackedButton } from "@/ui/TrackedButton";
import { SlettUtkastModal } from "./SlettUtkastModal";
export function SlettUtkastButtonAndModal() {
  const $ = _c(1);
  const modalRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const openModal = function openModal() {
      modalRef.current?.showModal();
    };
    t0 = <><TrackedButton variant="tertiary" onClick={openModal} className="self-start" tracking={knappKlikket.oversiktSide.slettUtkastModalTrigger}>Slett utkast</TrackedButton><SlettUtkastModal modalRef={modalRef} /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}